import { type FC, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Colors } from "@snapchat/snap-design-system";
import { AddIcon } from "@snapchat/snap-design-system-icons";

import { AbsoluteRoute } from "../../core/routes";
import { HeaderSectionContainer } from "../../lens-insights/components/shared";
import { Flexbox } from "../../shared/components";
import { API } from "../api/util";
import { ApisContext } from "../context";

import { PageTitle, apiButton, buttonIcon, headerSectionContainer, loadableContainer } from "./ApisHeader.styles";
import { AddApiButtonCta, MyApisTitle } from "./messages.generated";

export const ApisHeader: FC = () => {
    const navigate = useNavigate();
    const { setStep, setAgreement } = useContext(ApisContext);
    const goToCreateApi = useCallback(() => {
        navigate(AbsoluteRoute.APIS_CREATE);
    }, [navigate]);

    const handleAddApiClick = () => {
        setStep?.(API);
        setAgreement(false);
        goToCreateApi();
    };

    return (
        <HeaderSectionContainer className={headerSectionContainer}>
            <Flexbox flexDirection="row" className={loadableContainer}>
                <PageTitle>
                    <MyApisTitle />
                </PageTitle>
                <Button className={apiButton} type="primary" onClick={handleAddApiClick}>
                    <AddIcon fill={Colors.WHITE} className={buttonIcon} />
                    <AddApiButtonCta />
                </Button>
            </Flexbox>
        </HeaderSectionContainer>
    );
};
